// 會員路由
const name = '統計'
import Layout from '@/view/layout' // 主框架

export default {
  path: '/merchant/companydata',
  component: Layout,
  children: [
    {
      path: 'goodsstatistics',
      name: `goodsstatistics`,
      meta: {
        title: `${name}-商品統計`
      },
      component: () =>
        import(
          /* webpackChunkName: "companydata-goodsstatistics" */ '@/view/mall/datacube/goodsdata'
        )
    },
    {
      path: 'orderstatistics',
      name: `orderstatistics`,
      meta: {
        title: `${name}-交易統計`
      },
      component: () =>
        import(
          /* webpackChunkName: "companydata-orderstatistics" */ '@/view/mall/datacube/companydata/order'
        )
    },
    {
      path: 'distributordata',
      name: `distributordata`,
      meta: {
        title: `${name}-店鋪統計`
      },
      component: () =>
        import(
          /* webpackChunkName: "companydata-distributordata" */ '@/view/mall/datacube/distributordata'
        )
    },
    {
      path: 'accountingStatistics',
      name: `accountingStatistics`,
      meta: {
        title: `${name}-分賬統計`
      },
      component: () =>
        import(
          /* webpackChunkName: "companydata-accountingStatistics" */ '@/view/mall/datacube/accountingstatistics'
        ),
      children: [
        {
          path: 'detail/:itemId?',
          meta: {
            title: `${name}-分賬統計-檢視`
          },
          component: () =>
            import(
              /* webpackChunkName: "companydata-accountingStatistics-detail" */ '@/view/mall/datacube/accountingstatistics_detail'
            )
        }
      ]
    },
    {
      path: 'cashRecord',
      name: `cashRecord`,
      meta: {
        title: `${name}-提款記錄`
      },
      component: () =>
        import(/* webpackChunkName: "companydata-cashrecord" */ '@/view/mall/datacube/cashrecord')
    },
    {
      path: 'transactionStatistics',
      name: `transactionStatistics`,
      meta: {
        title: `${name}-店鋪交易統計`
      },
      component: () =>
        import(
          /* webpackChunkName: "companydata-transactionStatistics" */ '@/view/mall/marketing/transactionStatistics'
        )
    },
    {
      path: 'SalemanLoginHistory',
      name: `SalemanLoginHistory`,
      meta: {
        title: `${name}-導購簽到記錄`
      },
      component: () =>
        import(
          /* webpackChunkName: "companydata-SalemanLoginHistory" */ '@/view/guide/SalemanLoginHistory'
        )
    },
    {
      path: 'marketingsalesman',
      name: `marketingsalesman`,
      meta: {
        title: `${name}-店鋪導購員`
      },
      component: () =>
        import(/* webpackChunkName: "companydata-marketingsalesman" */ '@/view/guide/salesman')
    },
    {
      path: 'coupongrantset',
      name: `coupongrantset`,
      meta: {
        title: `${name}-優惠券發放設定`
      },
      component: () =>
        import(
          /* webpackChunkName: "companydata-coupongrantset" */ '@/view/member/cardticket/couponGrantSet'
        )
    },
    {
      path: 'shopactivities',
      name: `shopactivities`,
      meta: {
        title: `${name}-導購知識庫`
      },
      component: () =>
        import(/* webpackChunkName: "companydata-shopactivities" */ '@/view/guide/shopactivities'),
      children: [
        {
          path: 'editor/:itemId?',
          meta: {
            title: `${name}-導購知識庫-編輯`
          },
          component: () =>
            import(
              /* webpackChunkName: "companydata-shopactivities-editor" */ '@/view/guide/shopActivities_editor'
            )
        }
      ]
    },
    {
      path: 'shoppingguidenotification',
      name: `shoppingguidenotification`,
      meta: {
        title: `${name}-導購員通知`
      },
      component: () =>
        import(
          /* webpackChunkName: "companydata-shoppingguidenotification" */ '@/view/guide/shoppingguidenotification'
        ),
      children: [
        {
          path: 'editor/:itemId?',
          meta: {
            title: `${name}-導購員通知-編輯`
          },
          component: () =>
            import(
              /* webpackChunkName: "companydata-shoppingguidenotification-editor" */ '@/view/guide/shoppingguidenotification_editor'
            )
        }
      ]
    },
    {
      path: 'profitlist',
      name: `profitlist`,
      meta: {
        title: `${name}-業績統計`
      },
      component: () =>
        import(/* webpackChunkName: "companydata-profitlist" */ '@/view/mall/profit/list')
    },
    {
      path: 'salemancustomercomplaints',
      name: `salemancustomercomplaints`,
      meta: {
        title: `${name}-導購員投訴`
      },
      component: () =>
        import(
          /* webpackChunkName: "companydata-salemancustomercomplaints" */ '@/view/guide/salemanCustomerComplaints'
        )
    },
    {
      path: 'guide/qywx/addressBook',
      name: `guide_qywx_addressBook`,
      meta: {
        title: `${name}-企業微信-通訊錄`
      },
      component: () =>
        import(
          /* webpackChunkName: "companydata-guide-qywx-addressBook" */ '@/view/base/setting/addressBook/index'
        )
    },
    {
      path: 'financial/settlement/summary',
      name: `結算彙總`,
      component: () => import('@/view/financial/settlement/summary'),
      children: [
        {
          path: 'detail/:id?',
          component: () => import('@/view/financial/settlement/detailed')
        }
      ]
    }
  ]
}
